/**
 * Group/Line Form Page
 */

import { Tags } from 'lucide-react'
import { CatalogFormPage } from './CatalogFormPage'
import { useTranslation } from '@/hooks/useTranslation'

export function GroupFormPage() {
  const { t } = useTranslation()

  return (
    <CatalogFormPage
      config={{
        endpoint: 'groups',
        basePath: '/groups',
        title: t('catalogs.groups'),
        newTitle: t('catalogs.newGroup'),
        editTitle: t('catalogs.editGroup'),
        icon: Tags,
        fields: [
          { key: 'code', label: t('articles.code'), type: 'text' },
          { key: 'description', label: t('articles.description'), type: 'text', required: true },
        ],
      }}
    />
  )
}
